export class Author {
  constructor({ authorId, displayName, authorImage }) {
    this.id = authorId;
    this.displayName = displayName;
    this.image = authorImage;
  }
}
